import Header from './components/Header';
import Hero from './components/Hero';
import FAQSection from './components/FAQSection';
import FeaturesSection from './components/FeaturesSection';
import AboutSection from './components/AboutSection';
import MediaSection from './components/MediaSection';
import AppSection from './components/AppSection';
import RankingSection from './components/RankingSection';
import CardsSection from './components/CardsSection';
import TopicsSection from './components/TopicsSection';
import UpdatesSection from './components/UpdatesSection';
import CommentsSection from './components/CommentsSection';
import ContactSection from './components/ContactSection';
import IndexSection from './components/IndexSection';
import CarouselSection from './components/CarouselSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <FAQSection />
        <FeaturesSection />
        <AboutSection />
        <MediaSection />
        <AppSection />
        <RankingSection />
        <CardsSection />
        <TopicsSection />
        <UpdatesSection />
        <CommentsSection />
        <ContactSection />
        <IndexSection />
        <CarouselSection />
      </main>
      <Footer />
    </>
  );
}